<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction
        :isShow="isShow"
        :page="this"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>{{$helper.getWord('save')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card" v-for="(detail_table_element, index1) in formData.tableList" :key="index1">
          <div class="card-header">
              <h4 v-if="detail_table_element.type == 'sub'">{{$helper.getWord('Detail Table')}} {{index1}}</h4>
              <h4 v-if="detail_table_element.type == 'main'">{{$helper.getWord('Main Table')}}</h4>
              <div class=" buttonBar float-sm-right">
                <a href="javascript:void(0)" v-if="detail_table_element.type == 'sub'" @click="detail_del_table(index1)">
                    <i class="fas fa-minus-circle" style="font-size: 24px;"></i>
                  </a>
                <input   hidden />
              </div>
          </div>
          <div class="card-body">
            <div class="row">
              <Textbox
                :readonly="isEdit = (detail_table_element.isNew == true ? false : true)"
                v-model="detail_table_element.name"
                class="col-sm-6"
                :title="$helper.getWord('Table Name')"
                @keypress="preventCharacter(event)"
              />
            </div>
            <div class="row">
              <label class="col-form-label col-sm-3">{{$helper.getWord('Column Name')}}</label>
              <label class="col-form-label col-sm-2">{{$helper.getWord('Data type')}}</label>
              <label class="col-form-label col-sm-2">{{$helper.getWord('Size')}}</label>
              <label class="col-form-label col-sm-3">{{$helper.getWord('Display Name')}}</label>
              <label class="col-form-label col-sm-1" v-if="detail_table_element.type == 'main'">{{$helper.getWord('Show')}}</label>
              </div>
            <div class="row" v-for="(detail_column_element, index2) in detail_table_element.mb_form_column" :key="index2">
              <Textbox
                :readonly="(detail_table_element.type=='main' && index2<=3)?true:false"
                v-model="detail_column_element.column_name"
                class="col-sm-3"
                :nolabel="true"
              />
              <MobileSelectbox
               :readonly="(detail_table_element.type=='main' && index2<=3)?true:false"
                wrapperclass='col-sm-2'
                :options="lookups.data_type"
                v-model="detail_column_element.datatype"
                :nolabel="true"
                :key="componentkey"
                @input="dataTypeReturn"
                :id="'D_'+index1 +'_'+ index2"
              />
              <Textbox
                :readonly="(detail_table_element.type=='main' && index2<=3)?true: detail_column_element.length_readonly"
                v-model="detail_column_element.length"
                class="col-sm-2"
                :nolabel="true"
              />
              <Textbox
                :readonly="(detail_table_element.type=='main' && index2<=3)?true:false"
                v-model="detail_column_element.display_name"
                class="col-sm-3"
                :nolabel="true"
              />
              <mbCheckBox
              v-if="detail_table_element.type == 'main'"
                  class="col-sm-1"
                  :options="[
                        { Key: index2, Value: '' }
                      ]"
                  v-model="detail_column_element.isShow"
                  :list="selectColumnList"
              />
              <div class="col-sm-1"  v-if="detail_table_element.type != 'main'"></div>
              <div class="col-sm-auto buttonBar" v-if="detail_table_element.type=='sub' || (!(index2<=3) && detail_table_element.type == 'main')">
                <a href="javascript:void(0)" @click="detail_del_column(index1,index2)">
                    <i class="fas fa-minus-circle" style="font-size: 24px;"></i>
                  </a>
                <input   hidden />
              </div>
            </div>
            <button type="button" class="btn btn-info btn-block" @click="detail_add_column(index1)">
              <i class="fas fa-plus-circle"></i> {{$helper.getWord('Add Column')}}
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-info btn-block" @click="detail_add_table()">
          <i class="fas fa-plus-circle"></i> {{$helper.getWord('Add Detail Table')}}
        </button>
      </div>
    </section>
    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Model Builder",
  access_code: "MB_NEW01",
  icon: "fas fa-university",
  hidden: true,
  components: {},
  order: 6,
  data() {
    return {
      componentkey: 0,
      lookups: {
      },
      datatype_without_length:[],
      wfDtl: {},
      isShow: null,
      gridId: "form01",
      formData: {
      },
      ticon: false,
      deleteColumnList: [],
      deleteTableList: [],
      isEdit: true,
      selectColumnList:[]
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
    //helper.initFormGrid(this);
    if (window.innerWidth < window.innerHeight || window.innerWidth > 768) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
  },
  updated() {
    if (window.innerWidth < window.innerHeight) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  methods: {
    checkDataType(value, res){
        let index1 = res[1]
        let index2 = res[2]
        if(this.datatype_without_length.find(element => element == value)){
          this.formData.tableList[index1].mb_form_column[index2].length_readonly = true
          this.formData.tableList[index1].mb_form_column[index2].length = null
        }else{
          this.formData.tableList[index1].mb_form_column[index2].length_readonly = false
        }
    },
    dataTypeReturn(value,previous_value,component){
      let res = component.id.split("_")
      this.checkDataType(value,res)
    },
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow"]),
    wfAction(action) {
      let doSave = true;
      if (action && action.required_note) {
        doSave = false;
      }
      if (this.formData.declare) {
        if (
          this.formData.declare == true ||
          this.formData.declare[0] == "true"
        ) {
          this.SubmitButtonClicked(true, action.id, doSave);
        } else {
          helper.alert("Please apply the Declare");
        }
      } else {
        helper.alert("Please apply the Declare");
      }
    },
    cancelBtnClick(){
      this.$router.push("/Builder/ModelBuilder/list");
    },
    saveButtonClicked(){
      helper.loading();
      api.request(
        this,
        "post",
        `/model_builder/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData,
            deleteColumnList: this.deleteColumnList,
            deleteTableList: this.deleteTableList,
            selectColumnList:this.selectColumnList
          }
        },
        function(r) {
          helper.clearData(this);
          this.deleteColumnList=[];
          this.deleteTableList=[];
          this.$router.go(-1);
        },
        function(r) {
          helper.done();
        }
      );
    },
    wfNoteChanged(value) {
      this.wfNote = value;
    },
    detail_add_column(index1){
      this.formData.tableList[index1].mb_form_column.push({datatype: null, column_name: null,length: null, display_name: null})
    },
    detail_del_column(index1,index2){
      this.deleteColumnList.push(this.formData.tableList[index1].mb_form_column[index2])
      this.formData.tableList[index1].mb_form_column.splice(index2, 1);
      if(this.formData.tableList[index1].mb_form_column.length == 0){
        this.detail_del_table(index1);
      }
    },
    detail_del_table(index1){
      this.deleteTableList.push(this.formData.tableList[index1])
      this.formData.tableList.splice(index1, 1);
    },
    detail_add_table(){
      this.formData.tableList.push({type:"sub",isNew:true , mb_form_column:[{datatype: null, column_name: null,length: null, display_name: null}]})
    },
    toggleIcon() {
      this.ticon = !this.ticon;
    },
    SubmitButtonClicked() {

    },
    loadForm() {
      helper.loading();
      api.request(
        this,
        "post",
        `/model_builder/${this.gridId}_load`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id,
          }
        },
        function(r) {
          //this.wfDtl = r.data.wfDtl;
          this.formData = r.data.formData;
         if (this.formData.mainId == '00000000-0000-0000-0000-000000000000') {
            this.isEdit = false;
          }
          
          if(this.formData.tableList ==null) {
            this.formData.tableList = []
          }
        
          if(r.data.lookups != null){
            this.lookups = r.data.lookups
            for (const property in this.lookups) {
                this.lookups[property].forEach(element => {
                  element.Key = element.value
                  element.Value = element.display
                });
            }
          }else{
            this.lookups = {
              data_type: []
            }
          }
          if(r.data.datatype_without_length !=null){
            this.datatype_without_length = r.data.datatype_without_length
          }
          console.log( this.formData.tableList);
          
          this.formData.tableList.forEach((element1,index1) => {
            element1.mb_form_column.forEach((element2,index2) => {
              let res
              if(element1.type=='main')
                res=["M",index1,index2]
              else if(element1.type=='sub')
                res=["D",index1,index2]
              this.checkDataType(element2.datatype,res)
            });
          });
          setTimeout(() => {
          this.componentkey+=1

          }, 250);
          helper.done();

        },
        function(r) {
          helper.done();
        },
        null
      );

    },
    preventCharacter: function(event){
      //TODO: prevent client input special characters except underscore
    }
  },
  mounted() {
     this.loadForm();
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>